import { Grid } from '@mui/material';
import { ReactNode } from 'react';

export const EventItemContent = ({ children }: { children: ReactNode }) => {
  return (
    <Grid
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginTop: '8px',
        padding: '8px 12px',
        background: '#fff',
        borderRadius: '8px',
      }}
    >
      {children}
    </Grid>
  );
};
